import "./DSAUploads.scss";
import { Spinner } from "../account/misc/Spinner";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { AppContext } from "../../AppContext";
import { locationsState, mobileState } from "../../state/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { SearchableUpload } from "../dsa/EditScreenContentModal";
import { DeleteUploadModal } from "../dsa/DeleteUploadModal";
import UploadCard from "../dsa/UploadCard";
import { DisplayUploadDto } from "../../domain/DisplayUploadDto";
import PreviewModal from "../dsa/PreviewModal";
import { DsaPlaylistDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import UploadDisplayImage from "../dsa/UploadDisplayImage";
import QRDisplayUploadsApi from "../../api/QRDisplayUploadsApi";

export default function DSAUploads() {
  const { location } = useContext(AppContext);
  const [locations] = useRecoilState(locationsState);
  const mobile = useRecoilValue(mobileState);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [uploads, setUploads] = useState([] as SearchableUpload[]);
  const [playlists, setPlaylists] = useState([] as DsaPlaylistDto[]);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({} as DisplayUploadDto);
  const [isPreviewModal, setPreviewModal] = useState(false);

  const fetchUploads = useCallback(() => {
    setLoading(true);
    QRDisplayUploadsApi.getDisplayUploadsByLocationIds(locations.map(l => l.internalId!))
    .then(resp => {
      setLoading(false);
      const dus = resp.data as SearchableUpload[];
      dus.forEach(it => {
        it.visible = it.locationId === location.internalId;
      })
      setUploads(dus);
    })
    .catch(err => {
      setLoading(false);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPlaylists = useCallback(() => {
    DSAApi.getPlaylists().then(r => {
      setPlaylists(r.data);
    })
  }, [])

  useEffect(fetchUploads, [fetchUploads]);
  useEffect(fetchPlaylists, [fetchPlaylists]);

  function onSearchChange(search: string) {
    setSearch(search);
    uploads.forEach(function (it) {
      it.visible = (it.name!.toLowerCase()?.indexOf(search.toLowerCase()) || 0) > -1;
    });
    setUploads(uploads);
  }

  function onDeleteModalClose(fetch: boolean) {
    const selectedId = selected.id;
    setDeleteModal(false);
    setSelected({} as DisplayUploadDto);
    if (fetch) {
      playlists.forEach(p => {
        const entriesWithUpload = p.entries!.filter(e => e.uploadId !== selectedId);
        if (entriesWithUpload.length > 0) {
          entriesWithUpload.forEach(fe => {
            fe.sequence = entriesWithUpload.indexOf(fe);
          });
          p.entries = entriesWithUpload;
          DSAApi.updatePlaylist(p.id!, p).then(() => {
            console.log(`Removed upload ${selectedId} from playlist ${p.id!}`);
          });
        }
      });

      setTimeout(() => {
        fetchUploads();
      }, 100);
    }
  }

  return <div>
    {loading && <div className={'dsa'}>
      <div className={'spinner'}><Spinner /></div>
    </div>}

    {!loading && <section className={"dsau"}>
      <header>
        {mobile && <Input type="search" prefix={<SearchOutlined />} placeholder="Search Uploads" value={search}
          onChange={ev => onSearchChange(ev.target.value)} />}
        <h3>Uploads</h3>
        {uploads.length > 0 && uploads.filter(it => it.visible).length > 0 &&
          <UploadDisplayImage
            className="ant-btn grey"
            beforeUpload={() => setLoading(true)}
            afterUpload={() => {
              setLoading(false);
            }}
            uploads={uploads}
            setUploads={setUploads}
          />
        }

        {!mobile && <Input type="search" prefix={<SearchOutlined />} placeholder="Search Uploads" value={search}
          onChange={ev => onSearchChange(ev.target.value)} />}
      </header>

      {(uploads.length === 0 || uploads.filter(it => it.visible).length === 0) && <div className={"no-data"}>
        <img src="https://timber.mhmcdn.com/site/marketing/icons/Upload.svg" alt="Upload"/>
        <p>
          You don't have any uploads yet.
        </p>
        <div className={'upload-btn-wrapper'}>
          <UploadDisplayImage
            beforeUpload={() => setLoading(true)}
            afterUpload={() => {
              setLoading(false);
            }}
            uploads={uploads}
            setUploads={setUploads}
          />
        </div>
      </div>}

      {search && uploads.filter(it => it.visible).length === 0 && <div className="no-matches">
        No matches found.
      </div>}

      {uploads.length > 0 && uploads.filter(it => it.visible).length > 0 && <ul className="uploads">
        {uploads
          .filter(it => it.visible)
          .map(it => <UploadCard
            key={it.id}
            it={it}
            setDeleteModal={setDeleteModal}
            setSelected={setSelected}
            setPreviewModal={setPreviewModal}
            uploads={uploads}
            setUploads={setUploads}
          />)}
      </ul>}
    </section>}

    <DeleteUploadModal
      upload={selected}
      isVisible={isDeleteModal}
      onClose={onDeleteModalClose}
    />

    <PreviewModal
      previewType="upload"
      previewUploadId={selected.id}
      isVisible={isPreviewModal}
      onClose={() => setPreviewModal(false)}
    />
  </div>
}
